<div class="center-container space-between margin">
  <div class="title"><span i18n>顏色</span>&nbsp;({{viewModel.apiResult().colors.length}})</div>
  <button appFocusRemove (click)="toggleMode()">
    <app-image-loading alt="放大" i18n-alt
                       [clickable]="true"
                       [src]="viewModel.mode() ? 'assets/icon_color_grid.svg' : 'assets/icon_color_flex.svg'"
                       [targetWidth]="15.5"
                       [targetHeight]="15.5"/>
  </button>
</div>
<div class="relative color-section">
  <div #big class="color-container wrapper color-grid"
       [class.display]="viewModel.mode()">
    <button class="relative column-container align-center space-between gray-item color-item" appFocusRemove
            [style.height.px]="colorHeight()"
            *ngFor="let color of viewModel.apiResult().colors; trackBy: trackByFn"
            [class.selected]="viewModel.currColor()?.id === color?.id"
            (click)="viewModel.setColor(color)">
      <button appFocusRemove class="zoom" (click)="openGallery(color)">
        <app-image-loading src="assets/icon_zoom.svg" alt="放大" i18n-alt
                           [clickable]="true"
                           [targetWidth]="17.5"
                           [targetHeight]="17.5"/>
      </button>
      <app-image-loading
        [clickable]="true"
        [targetWidth]="colorWidth()"
        [targetHeight]="colorWidth()"
        [src]="(viewModel.colorImages().get(color?.id ?? '') ?? '')"
        [alt]="color?.color?.name ?? ''"/>
      <div class="flex-grow full-width bg-white"></div>
      <div class="name">{{color?.color?.name}}</div>
    </button>
  </div>
  <div #small class="small-color-container margin"
       [class.display]="!viewModel.mode()">
    <button class="row-container gray-item color-flex-item" appFocusRemove *ngFor="let color of viewModel.apiResult().colors; trackBy: trackByFn"
            [class.selected]="viewModel.currColor()?.id === color?.id"
            (click)="viewModel.setColor(color)">
      <div class="img">
        <app-image-loading
          [clickable]="true"
          [targetWidth]="35"
          [targetHeight]="35"
          [src]="(viewModel.colorImages().get(color?.id ?? '') ?? '')"
          [alt]="color?.color?.name ?? ''"/>
      </div>
      <div class="name">{{color?.color?.name}}</div>
    </button>
  </div>
  <div class="wrapper" [style.height.px]="colorContentHeight()"></div>
</div>
